import { render, staticRenderFns } from "./OrderInfoView.vue?vue&type=template&id=6db111fb&scoped=true"
import script from "./OrderInfoView.vue?vue&type=script&lang=js"
export * from "./OrderInfoView.vue?vue&type=script&lang=js"
import style0 from "./OrderInfoView.vue?vue&type=style&index=0&id=6db111fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db111fb",
  null
  
)

export default component.exports